export default __webpack_public_path__ + "static/media/logo_archdiocese_white.411e0ffd.png";